import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Separator } from "@/components/ui/separator";
import { DropboxConfigForm } from "@/components/integrations/DropboxConfigForm";
import { useApiCredentials } from "@/hooks/useIntegrations";

export function IntegrationsTab() {
  const { isLoading } = useApiCredentials();

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <Skeleton className="h-6 w-48" />
          <Skeleton className="h-4 w-64" />
        </CardHeader>
        <CardContent>
          <Skeleton className="h-24 w-full" />
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium">Integrations</h3>
        <p className="text-sm text-muted-foreground">
          Connect external systems to sync data with Gravity Assist
        </p>
      </div>

      <Separator />

      <DropboxConfigForm />
    </div>
  );
}
